exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hotel-list-header[data-v-505e938d]{border-radius:4px 4px 0 0}", ""]);

// exports
